export default __webpack_public_path__ + "static/media/simple-Line-Icons.d25156c9.woff";